export function formatArticleDate(article) {
  const value = article.published_date || article.date || article.created_at;
  if (!value) return '';
  // API timestamps without an offset represent UTC; dates stay calendar dates.
  const timestamp = String(value).replace(' ', 'T');
  const needsOffset = timestamp.includes('T') && !/(Z|[+-]\d{2}:?\d{2})$/i.test(timestamp);
  const date = new Date(needsOffset ? `${timestamp}Z` : timestamp);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleDateString('en-US', {
    day: 'numeric', month: 'short', year: 'numeric', timeZone: 'Asia/Ulaanbaatar'
  });
}
